<template>
  <div class="bid-dialog-display box">
    <div class="banner-content">
      <div class="precon-bid" >
        <img src="https://assets.p-suite.io/ps_icon_blue.svg" alt="PreconBid">

      </div>

      <div class="divider" />

      <div class="dialog-message is-block">
        <div>Create a login to track all your bid invites in one place. <span class="is-link" @click="handleSignUp">More Info/Sign Up</span></div>
        <div class="not-bold-mobile">If you already have a PreconBid account, <span class="is-link" @click="handleLogin">Click Here</span> to login</div>
      </div>

      <o-icon icon="times" class="close" @click="handleCancel" />
    </div>
  </div>
</template>

<script setup lang="ts">

  import { dismissBidDialog } from "@/use/BidDialog";

  const emit = defineEmits<{
    'close': [],
  }>();

  function handleLogin() {
    window.open(import.meta.env.VITE_BID_API_APP_URL + 'login', '_blank');
  }

  function handleSignUp() {
    window.open(import.meta.env.VITE_BID_API_APP_URL + 'sign-up', '_blank');
  }

  async function handleCancel() {
    dismissBidDialog();
    emit('close');
  }

</script>

<style lang="scss" scoped>

  .bid-dialog-display {
    &.box {
      margin-bottom: 0px !important;
      min-width: 400px;
      font-weight: bold;

      .precon-bid {
        display: flex;
        flex: 0 0 40px;
        width: 40px;
        align-items: center;
        justify-content: center;
      }

      .banner-content {
        display: flex;
        align-items: center;
        position: relative;
        width: 100%;
        min-width: 0;
      }

      .is-bold {
        font-weight: bold;
      }

      .is-link {
        color: $primary;
        cursor: pointer;
      }

      .divider {
        flex: 0 0 1px;
        width: 1px;
        background-color: $primary;
        margin-left: 1em;
        margin-right: 1em;
        height: stretch;
      }

      .dialog-message {
        flex: 1 1 auto;
        min-width: 0;
        padding-top: .5em;
        padding-right: 2rem;
        padding-bottom: .5em;
      }

      .has-margin-right {
        margin-right: .5em;
      }

      .close {
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
      }
    }
  }
  @media (max-width: 768px) {
    .bid-dialog-display {
      &.box {
        margin: 0;
        padding: 12px 16px;
        width: 100%;
        min-width: 0;
        max-width: 100%;
        font-size: 12px;
      }
      .not-bold-mobile {
        font-weight: normal;
      }
    }
  }

</style>

<style lang="scss">

  .media {
    display: none !important;
  }

  .notification.marketing-banner-notification {
    padding: 2px !important;
    max-width: 775px !important;
  }

  @media (max-width: 768px) {
    .b-notices.marketing-banner-notices {
      padding: 8px;
    }

    .notification.marketing-banner-notification {
      width: 100%;
      max-width: none !important;
    }
  }

</style>
